import auth from "../../middlewares/auth";
export const gradeGroupRoute = [
  {
    path: '/grade-group',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/grade_group/GradeGroupList'),
    name: 'grade_group',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/grade-group-add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/grade_group/GradeGroupForm'),
    name: 'grade_group_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/grade-group-edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/grade_group/GradeGroupForm'),
    name: 'grade_group_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];